import { render } from "./SoudeurCard.vue?vue&type=template&id=c65c4f7c"
import script from "./SoudeurCard.vue?vue&type=script&lang=js"
export * from "./SoudeurCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__